
// import {configureStore} from "@reduxjs/toolkit";
// import rootReducer from "./rootReducer";

// const store=configureStore({
//   // here we can config. the store but firstly combine all in the rootReducer 
//     reducer:{
//       loginDetails:rootReducer
//     }
// })
// export default store;


import { configureStore } from '@reduxjs/toolkit'
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from '@reduxjs/toolkit/query'
import { api } from './api.js'
import rootReducer from './rootReducer.js'

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [api.reducerPath]: api.reducer,
    data:rootReducer
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)